import React from 'react';
import {useSelector} from 'react-redux';
import {t} from '@lingui/core/macro';

import {IMessengerChat, maxChatAPI} from 'entities/notification';
import {userSelector} from 'entities/user';

import NotifyChannelSection from '../NotifyChannel/NotifyChannelSection';
import NotifyChannelRow from '../NotifyChannel/NotifyChannelRow';
import NotifyChannelEditModal from '../NotifyChannel/NotifyChannelEditModal';
import NotifyChannelDeleteModal from '../NotifyChannel/NotifyChannelDeleteModal/NotifyChannelDeleteModal';

import MaxChatModal from './MaxChatModal';

const MaxChats: React.FC = () => {
    const user = useSelector(userSelector);

    const renderRow = (item: IMessengerChat) => (
        <NotifyChannelRow
            key={item.id}
            item={item}
            title={item.chat}
            api={maxChatAPI}
            activatedText={t`Чат активирован`}
            deactivatedText={t`Чат деактивирован`}
            renderEditModal={(modal) => (
                <NotifyChannelEditModal
                    {...modal}
                    item={item}
                    api={maxChatAPI}
                    header={t`Редактирование чата`}
                    successText={t`Описание Max чата успешно обновлено`}
                />
            )}
            renderDeleteModal={(modal) => (
                <NotifyChannelDeleteModal
                    {...modal}
                    item={item}
                    api={maxChatAPI}
                    header={t`Удаление Max-чата`}
                    question={t`Вы уверены, что хотите удалить Max-чат`}
                    name={item.chat}
                    successText={t`Чат удален`}
                />
            )}
        />
    );

    return (
        <NotifyChannelSection
            api={maxChatAPI}
            title={t`Max - чаты для уведомлений`}
            limit={user?.tariff.max_chats_max_count_limit}
            firstColumn={{label: t`ID чата`, sort: 'id'}}
            create={{label: t`Добавить чат`, exceededType: 'max_chats', Modal: MaxChatModal}}
            renderRow={renderRow}
        />
    );
};

export default MaxChats;
